import messageExceptionCaster from "@hpo/client/message-exception-caster";

/** @deprecated : Use messageExceptionCaster instead  */
export default function getErrorMessage(error: unknown) {
  return messageExceptionCaster.cast(error).message;
}
